const SDK_VERSION = '7.104.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
